import { CHECKOUT_STEPS, checkoutStepForRoute } from "./checkoutSteps";

// On the VSGA website (vsga.org/purchase-vip-card) the steps live after the "#", which HubSpot's
// tracking code doesn't see: it records one page view when the page loads. For each step we send:
//  - a page view under its own path ("/purchase-vip-card/step2") and title ("Purchase VIP Card –
//    Step 2: Find Your Account"), so contact activity timelines show each step. HubSpot's Pages
//    report still groups them under the one HubSpot page.
//  - the "VIP Checkout Step Viewed" custom behavioral event, which is what HubSpot reports and
//    funnels use to count visits per step.
// Once the visitor's email is known (a member found on Step 2, or typed on Step 3 / gift checkout),
// "identify" links this browser's activity, including the earlier anonymous steps, to that contact.
// https://developers.hubspot.com/docs/api/events/tracking-code
const STEP_VIEWED_EVENT = "pe22804395_vip_checkout_step_viewed";
let pageTitle: string | null = null;
let identifiedEmail: string | null = null;

export function trackHubSpotStepView(route: string, vipPackage?: string, email?: string) {
  // Only when running on the HubSpot page; the standalone Render site has no HubSpot tracking code.
  if (!document.getElementById("vsga-vip-app")) return;
  if (pageTitle === null) pageTitle = document.title;
  const step = checkoutStepForRoute(route);
  document.title = step ? [pageTitle, step.label].filter(Boolean).join(" – ") : pageTitle;

  const page = window.location.pathname.replace(/\/+$/, "");
  const hsq = ((window as any)._hsq = (window as any)._hsq || []);
  const cleanEmail = (email || "").trim().toLowerCase();
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail) && cleanEmail !== identifiedEmail) {
    // Takes effect with the page view below.
    hsq.push(["identify", { email: cleanEmail }]);
    identifiedEmail = cleanEmail;
  }
  hsq.push(["setPath", page + route]);
  hsq.push(["trackPageView"]);

  if (step) {
    hsq.push([
      "trackCustomBehavioralEvent",
      {
        name: STEP_VIEWED_EVENT,
        properties: {
          step: step.key,
          step_label: step.label,
          step_number: CHECKOUT_STEPS.indexOf(step) + 1,
          ...(vipPackage ? { vip_package: vipPackage } : {}),
        },
      },
    ]);
  }
}
